import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M94 98c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M16.5 69a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#00D8D8" d="M15.5 55a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#0597A3"
      d="M73.63 58.98c9.455 0 17.12-7.665 17.12-17.12s-7.665-17.12-17.12-17.12-17.12 7.665-17.12 17.12 7.665 17.12 17.12 17.12"
    />
    <path
      fill="#0597A3"
      d="M98.54 77.34c1.06 0 1.71-1.14 1.22-2.08C94.94 66 85.01 58.97 73.97 58.97s-21.49 6.84-26.01 16.69c-.42.91.3 1.94 1.3 1.93l49.29-.26z"
    />
    <path
      fill="#00D8D8"
      d="M47.28 62.23c9.455 0 17.12-7.665 17.12-17.12s-7.665-17.12-17.12-17.12-17.12 7.665-17.12 17.12 7.665 17.12 17.12 17.12"
    />
    <path
      fill="#00D8D8"
      d="M72.2 80.59c1.06 0 1.71-1.14 1.22-2.08-4.82-9.26-14.75-16.29-25.79-16.29s-21.49 6.84-26.01 16.69c-.42.91.3 1.94 1.3 1.93l49.29-.26zM111.63 39.93h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M30.55 98.43l-3.94-3.94 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94c-.59.59-.59 1.54 0 2.12s1.54.59 2.12 0l3.94-3.94 3.94 3.94c.59.59 1.54.59 2.12 0s.59-1.54 0-2.12"
    />
  </svg>
);
const SvgEnrichedIconInternalUsersInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconInternalUsersInverted);
export default Memo;
